// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Entity } from '../../../@types';

// context
import { ContextUser } from '../../../App.context';

// layouts
import { Authenticated } from '../../layouts/Authenticated/Authenticated';

// mui
import { Container, Grid, Typography } from '@mui/material';

// pages
import { Documents } from './Documents/Documents';

// cards
import { CardProfile } from '../../cards/CardProfile/CardProfile';
import { CardTraceability } from '../../cards/CardTraceability/CardTraceability';

export const PageProfile = () => {
	// context
	const { user } = useContext(ContextUser);

	// hooks
	const { t } = useTranslation();

	// vars
	const hasDocuments = false;

	return (
		<Authenticated>
			<Container maxWidth={false}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography color="common.white" variant="h2">
							{t('profile')}
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<CardProfile />
					</Grid>
					<Grid item xs={12}>
						<Typography color="common.white" variant="h2">
							{t('traceability')}
						</Typography>
					</Grid>
					{(user?.entities as Entity[])?.map((entity) => {
						return (
							<Grid item xs={12}>
								<CardTraceability entityId={entity.id} />
							</Grid>
						);
					})}

					{hasDocuments && (
						<Grid hidden item xs={12}>
							<Documents />
						</Grid>
					)}
				</Grid>
			</Container>
		</Authenticated>
	);
};
